import { ReactNode, createContext } from "react";
import useTipoTerceiro, { TipoTerceiroType, CreateTipoTerceiroType, UpdateTipoTerceiroType} from "../context/hooks/useTipoTerceiro";

interface TipoTerceiroContextProviderProps {
    children: ReactNode;
}

export interface TipoTerceiroContextData {
    getAllTipoTerceiroPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<TipoTerceiroType[] | null>;
    setTipoTerceiro: any;
    tipoTerceiro: TipoTerceiroType;
    setListTipoTerceiro: any;
    listTipoTerceiro: TipoTerceiroType[];
    setInitialListTipoTerceiro: any;
    initialListTipoTerceiro: TipoTerceiroType[];
    setPageCount: any;
    pageCount: number;
    createTipoTerceiro: (createTipoTerceiroType: CreateTipoTerceiroType) => Promise<CreateTipoTerceiroType | null>;
    updateTipoTerceiro: (updateUserTypeType: UpdateTipoTerceiroType) => Promise<UpdateTipoTerceiroType | null>;
    deleteTipoTerceiro: (id: number) => Promise<TipoTerceiroType | null>;
}

const initialState: TipoTerceiroContextData = {
    getAllTipoTerceiroPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setTipoTerceiro: () => { },
    tipoTerceiro: {
        id: 0,
        type: "",
        empresaId: 0,
    },
    setListTipoTerceiro: () => {},
    listTipoTerceiro: [],
    setInitialListTipoTerceiro: () => {},
    initialListTipoTerceiro: [],
    setPageCount: () => {},
    pageCount: 0,
    createTipoTerceiro: async (createTipoTerceiroType: CreateTipoTerceiroType) => {
        return Promise.resolve(null);
    },
    updateTipoTerceiro: async (updateTipoTerceiroType: UpdateTipoTerceiroType) => {
        return Promise.resolve(null);
    },
    deleteTipoTerceiro: async (id: number) => {
        return Promise.resolve(null);
    },
};

export const TipoTerceiroContext =
    createContext<TipoTerceiroContextData>(initialState);

export default function TipoTerceiroContextProvider({
    children,
}: TipoTerceiroContextProviderProps) {
    const {
        getAllTipoTerceiroPaged,
        createTipoTerceiro,
        updateTipoTerceiro,
        deleteTipoTerceiro,
        tipoTerceiro,
        setTipoTerceiro,
        setListTipoTerceiro,
        listTipoTerceiro,
        initialListTipoTerceiro,
        setInitialListTipoTerceiro,
        setPageCount,
        pageCount,
    } = useTipoTerceiro();

    return (
        <TipoTerceiroContext.Provider
            value={{
                getAllTipoTerceiroPaged,
                createTipoTerceiro,
                updateTipoTerceiro,
                deleteTipoTerceiro,
                tipoTerceiro,
                setTipoTerceiro,
                setListTipoTerceiro,
                listTipoTerceiro,
                initialListTipoTerceiro,
                setInitialListTipoTerceiro,
                setPageCount,
                pageCount,
            }}
        >
            {children}
        </TipoTerceiroContext.Provider>
    );
}